/**
 * Maps Firebase Auth error codes to user-friendly messages in Portuguese
 */
const FIREBASE_AUTH_ERROR_MESSAGES = {
  'auth/invalid-email': 'Email inválido. Verifique o formato do endereço.',
  'auth/user-disabled': 'Esta conta foi desativada. Entre em contato com o suporte.',
  'auth/user-not-found': 'Nenhuma conta encontrada com este email.',
  'auth/wrong-password': 'Senha incorreta. Tente novamente.',
  'auth/invalid-credential': 'Email ou senha incorretos. Verifique e tente novamente.',
  'auth/invalid-login-credentials': 'Email ou senha incorretos. Verifique e tente novamente.',
  'auth/email-already-in-use': 'Este email já está cadastrado. Tente fazer login.',
  'auth/weak-password': 'A senha deve ter pelo menos 6 caracteres.',
  'auth/operation-not-allowed': 'Operação não permitida. Entre em contato com o suporte.',
  'auth/too-many-requests': 'Muitas tentativas. Aguarde alguns minutos e tente novamente.',
  'auth/network-request-failed': 'Erro de conexão. Verifique sua internet e tente novamente.',
  'auth/requires-recent-login': 'Por segurança, faça login novamente antes de continuar.',
  'auth/popup-closed-by-user': 'Login cancelado. Tente novamente.',
  'auth/cancelled-popup-request': 'Aguarde o popup anterior fechar e tente novamente.',
  'auth/popup-blocked': 'O popup foi bloqueado. Permita popups para este site e tente novamente.',
  'auth/account-exists-with-different-credential': 'Já existe uma conta com este email. Use email e senha para fazer login.',
  'auth/admin-restricted-operation': 'Operação não permitida. Entre em contato com o suporte.'
};

export function getAuthErrorMessage(error) {
  if (!error) return null;
  const code = error?.code || error?.message;
  return FIREBASE_AUTH_ERROR_MESSAGES[code] || error?.message || 'Ocorreu um erro. Tente novamente.';
}
